import { useEffect } from 'react';
import { compose } from 'ramda';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { dialogs as processInfoDialogs } from 'features/other/processInformation/constants';
import { reset } from 'features/views/taskSearch/actions';
import { dialogs as taskSearchDialogs } from 'features/views/taskSearch/constants';
import { TASK_SEARCH_FORM_NAME } from 'features/views/taskSearch/form';
import TaskForwardingModal from 'pages/TaskDetail/modals/TasksForwarding/TaskForwardingModal';

import Filter from './components/Filter';
import ResultsTable from './components/ResultsTable';
import Toolbar from './Toolbar';

export const TaskSearch = () => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(reset());
		},
		[dispatch],
	);

	const floatingDialogs = (
		<>
			<SubmitFormDialog pageName={TASK_SEARCH_FORM_NAME} />
			<Dialog mui name={processInfoDialogs.processedTasks}>
				{getLabelMessage('processInformation:processedTasks')}
			</Dialog>
			<Dialog mui name={processInfoDialogs.userCanProcessMax10Tasks}>
				{getLabelMessage('processInformation:userCanProcessMax10Tasks')}
			</Dialog>
			<Dialog mui name={processInfoDialogs.userDoesntHavePermissions}>
				{getLabelMessage('processInformation:userDoesntHavePermissions')}
			</Dialog>
			<Dialog mui name={taskSearchDialogs.tooManyResults}>
				{getLabelMessage('common:tooManyResults')}
			</Dialog>
		</>
	);

	return (
		<Panel screenId={PAGES.taskSearch.id} screenName={PAGES.taskSearch.name} floatingDialogs={floatingDialogs}>
			<TaskForwardingModal id={MODALS.task_forwarding} />
			<PaperWithToolbar
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.taskSearch, initiallyOpen: true }}
			>
				<ResultsTable />
			</PaperWithToolbar>
		</Panel>
	);
};

export default compose(
	codelistProvider(codelists.taskTypes, 'taskTypesCodelist'),
	codelistProvider(codelists.taskSubtypes, 'taskTypesCodelist'),
	codelistProvider(codelists.taskStatus, 'taskStatusCodelist'),
	codelistProvider(codelists.finishTypes, 'finishTypesCodelist'),
	codelistProvider(codelists.finishTypesAll, 'finishTypesAllCodelist'),
)(TaskSearch);
